import styled from 'styled-components';
import {device} from '../../../../styled/device';
import {Button} from '../../../../components/Button';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 30%;
  right: 5%;
  width: 300px;
  height: 191px;
  background: #ffffff;
  box-shadow: 0 23px 26px #0000001a;
  border: 1px solid #e6e8ec;
  border-radius: 24px;
  z-index: 5;
  padding: 24px;

  @media (max-width: ${device.tablet}) {
    position: fixed;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 16px;
    width: 100%;
    height: auto;
    background-color: #f7fafc;
    border-top: 1px solid $n6;
    border-radius: 0;
    z-index: 5;
    top: auto;
    bottom: 0;
    left: 0;
  }
`;

export const ButtonStyled = styled(Button)`
  @media (max-width: ${device.tablet}) {
    height: 52px;
  }

  @media (max-width: ${device.mobileM}) {
    font-size: 16px;
  }
`;

export const Title = styled.div`
  font-family: Poppins-Regular, sans-serif;
  font-size: 28px;
  margin-top: 20px;

  @media (max-width: ${device.tablet}) {
    display: none;
  }
`;
